import MockAdapter from 'axios-mock-adapter/types'

export function mockIndexes(mocker: MockAdapter) {
  mocker.onGet('/market/indexes').reply((config) => {
    return [
      200,
      {
        code: 200,
        data: {
          nextFundingTime: [Date.now()],
          WETH: [Date.now(), '1000'],
          WBTC: [Date.now(), '10000'],
          WAVA: [Date.now(), '0.9'],
        },
      },
    ]
  })
}
